// extracted by mini-css-extract-plugin
module.exports = {"conculision_divider":"styles_conculision_divider__UDpZE","question_body":"styles_question_body__3tK3c"};